import React from 'react'
import ItemPoster from './ItemPoster'
import ReactScrollLink from '../General/ReactScollLink'
import Translation from '../General/Translation';
import ItemSwitch from './ItemSwitch';
import withIsInViewport from '../hooks/withIsInViewport';
import getMovieTitle from '../functions/getMovieTitle';
import getBackgroundPosterObj from '../functions/getBackgroundPosterObj';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import getData from '../functions/getData';
import { CLI, FRONT, PROGRAM_CINEMAS, UI_TRAILER } from '../constants/state';
import FskWrapper from '../MovieInformation/FskWrapper';
import ItemPerformancesContainer from './ItemPerformancesContainer';
import { MASTERMULTITOTAL } from '../constants/multiCinemaModes';
import getCinemasPerMovie from '../functions/getCinemasPerMovie';
import CinemaIcon from '../BackgroundFormatItem/CinemaIcon';
import getPosterAttributeSettings from '../functions/getPosterAttributeSettings';
import getAttributesDisplaySettings from '../functions/getAttributesDisplaySettings';
import getBluePrices from '../functions/getBluePrices';
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet';
import ItemAttributesContainer from './ItemAttributesContainer';

const mapStateToProps = (state, ownProps) => ({
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation']),    
    cinemas: getData(state, PROGRAM_CINEMAS),
    cliData: getData(state, CLI),
    cinemaDataFront: getData(state, FRONT),
})

const PosterFormatItem = ({
    itemID, 
    itemData, 
    translation, 
    scrollToPosition, 
    isMobile=false, 
    onClickItem, 
    cinemaDataFront, 
    isOverview, 
    dayFilters,
    index = '', 
    theme,
    showPerformances, 
    filterType, 
    filterValue,
    refElemViewport,
    cliData,
    cinemas,
    isInViewport,
    shouldPlayTrailer = false, 
    queryStringValues,
    isConnectedFast,
    overviewFilterIgnoreOnPerformances,
    hasYoutubeCookieConfirmation,
    onOpenPerformancePage=null, 
    toggleMovieTimesOnMobileView=null
}) => {
    const {
        poster_styling,
        program_overview_list_style
    } = cinemaDataFront
    const { title, images, technologyAttributes, performances, posterAttribute, fsk, trailerURL, pk } = itemData
    const poster = getBackgroundPosterObj(images)
    const currentTitle = getMovieTitle(itemData)
    const borderClass = showPerformances ? ' theme-radius-posters-top' : ' theme-radius-posters-full'
    const relevantCinemas = cliData.multiCinemaMode === MASTERMULTITOTAL ? getCinemasPerMovie(performances) : []
    const bluePricesClass = getBluePrices(technologyAttributes)
    const performanceFilterIsSet = checkPerformanceFilterIsSet(technologyAttributes, filterType, filterValue, queryStringValues)
    const {noAttributesToDisplay, technologyAttributesWithoutIcons, technologyAttributesWithIcons, noAttributesWithIconsToDisplay, noAttributesWithoutIconsToDisplay} = getAttributesDisplaySettings(technologyAttributes, performances, filterValue, filterType, queryStringValues, performanceFilterIsSet, translation)
    const {posterAttributeTop ,posterAttributeBottom, hasPosterAttributeClass} = getPosterAttributeSettings(posterAttribute)

    const onClick = () => {
        if(program_overview_list_style === 'colored_blocks') {
            onClickItem({movieId: itemID, movieTitle: title, index: index})
        } else {
            toggleMovieTimesOnMobileView()
        }
    }

    const posterFormatItem = () => {
        if(isOverview) {
            return  <div className="overview-poster-format-item">
                        <div className={"poster-format-item theme-radius-posters-full" + bluePricesClass}>
                            <ReactScrollLink className={"picture-wrapper-link"}  onClick={() => onClick()}  to={itemID + ' movieInformation'} smooth={true} offset={-100}>
                                <ItemPoster 
                                    title={currentTitle} 
                                    poster={poster} 
                                    isMobile={isMobile}
                                    translation={translation}
                                />
                            </ReactScrollLink>
                        </div>
                        {posterAttributeTop && <div className="poster-attribute theme-radius-posters-top poster-attribute-text top-attribute">
                                {posterAttribute.name}
                            </div>
                        }
                        {posterAttributeBottom && <div className="poster-attribute poster-attribute-text theme-radius-posters-bottom bottom-attribute">
                                {posterAttribute.name}
                            </div>
                        }
                    </div>
        } else {
            // const posterRef = createRef(null)
            return (
                <div className={"poster-format-item" + bluePricesClass + ' ' + poster_styling} ref={refElemViewport}>       
                    <ReactScrollLink className={"picture-wrapper" + borderClass + ' ' + pk} onClick={() => onClickItem({id: itemID, movieTitle: title, index: index})} to={scrollToPosition + ' openMovieInformation'} smooth={true} offset={-200}>
                        <ItemSwitch
                            index={index}
                            title={currentTitle} 
                            poster={poster} 
                            trailerURL={trailerURL}
                            translation={translation} 
                            isInViewport={isInViewport}
                            isMobile={isMobile}
                            fsk={fsk}
                            shouldPlayTrailer={shouldPlayTrailer}
                            trailerAutoplay={shouldPlayTrailer}
                            isConnectedFast={isConnectedFast}
                            hasYoutubeCookieConfirmation={hasYoutubeCookieConfirmation}
                        />

                        {posterAttributeTop && <div className="poster-attribute poster-attribute-text theme-radius-posters-top top-attribute">
                                {posterAttribute.name}
                            </div>
                        }
                        {posterAttributeBottom && <div className="poster-attribute poster-attribute-text bottom-attribute">
                                {posterAttribute.name}
                            </div>
                        }
                       {poster_styling === "hoveranimation" && <div className='poster-info'>
                            <FskWrapper fsk={fsk}/>
                            <div className='tickets-button'><div className='tickets-icon'></div><p className=''><Translation id="tickets" trans={translation}></Translation></p></div>                                
                            <div className='attributes-container'>
                                {!noAttributesToDisplay && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                                {!noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                    <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                </div>}
                                {!noAttributesWithoutIconsToDisplay && <div className='attributes-without-icons'>
                                    <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributesWithoutIcons} />
                                </div>}
                            </div>
                        </div>}
                        {poster_styling === "fsk_on_poster"  && (fsk === 16 || fsk === 18) && <div className={"poster-info fsk-hint-poster theme-radius-posters-full"}>
                            <FskWrapper fsk={fsk}/>
                        </div>}
                    </ReactScrollLink>

                    {(poster_styling === "standard" || poster_styling === "fsk_on_poster") &&
                    <div className={"attributes-wrapper" + hasPosterAttributeClass}>
                        <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributes} />
                    </div>}
                    <div className={relevantCinemas.length !== 0 ? 'horizontal-flex-wrapper theme-radius-posters-bottom with-cinemas-icons' : 'horizontal-flex-wrapper theme-radius-posters-bottom'}>
                        {showPerformances && <ItemPerformancesContainer
                            movieId={itemID}
                            itemData={itemData}
                            filterValue={filterValue}
                            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                            filterType={filterType}
                            movieIndex={index}
                            scrollToPosition={scrollToPosition} 
                            dayFilters={dayFilters}
                            theme={theme}
                            queryStringValues={queryStringValues}
                            performances={performances} 
                            isMobile={isMobile}
                            onClick={() => onClickItem({id: itemID, movieTitle: title, index: index})} 
                            onOpenPerformancePage={onOpenPerformancePage}
                        />}
                        {relevantCinemas.length !== 0 && 
                            <div className='cinemas-icon-wrapper'>
                                {relevantCinemas.map((cinemaPk, index) => {
                                    return <CinemaIcon cinemaData={cinemas[cinemaPk]} key={index} />
                                })}
                            </div>
                        }
                    </div>
                </div>
            )
        }
    }
    
    return (
        <div className={'poster-format-item-wrapper cursor-pointer'}>    
            {posterFormatItem()}
        </div>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(withIsInViewport(PosterFormatItem))